import { Injectable } from '@angular/core';
import { ProductListComponentService } from '@spartacus/storefront';
const itemsPerPage = 18;
@Injectable({
  providedIn: 'root',
})
export class CustomProdListService extends ProductListComponentService {
  defaultPageSize = itemsPerPage;
}
